import { NavLink, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  FileText, 
  FolderOpen
} from 'lucide-react';

const navItems = [
  { to: '/dashboard', label: 'Home', icon: LayoutDashboard },
  { to: '/generate', label: 'Generate', icon: FileText },
  { to: '/categories', label: 'Categories', icon: FolderOpen },
];

export function MobileNav() {
  const location = useLocation();

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-card/95 backdrop-blur-lg border-t border-border z-50 safe-bottom">
      <div className="flex items-center justify-around py-2 px-1">
        {navItems.map(({ to, label, icon: Icon }) => {
          const isActive = location.pathname === to;
          return (
            <NavLink
              key={to}
              to={to}
              className={`
                flex flex-col items-center gap-1 px-4 py-2 rounded-xl text-xs font-medium
                transition-all duration-200 min-w-[64px]
                ${isActive 
                  ? 'text-primary-foreground bg-primary' 
                  : 'text-muted-foreground hover:text-foreground'
                }
              `}
            >
              <Icon size={20} strokeWidth={isActive ? 2.5 : 2} />
              <span className="text-[10px] leading-tight">{label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
